const TableContent = ({
    isTableBorderEnabled,
    tempBorderColor,
    isLineItemNumCheckEnabled,
    lineNumWidth,
    taHeadFontSize,
    taHeadFontColor,
    isTaHeadBgColorEnabled,
    taHeadBgColor,
    lineNumLabelText,
    itemWidth,
    isItemEnabled,
    itemLabelText,
    isDescLabelEnabled,
    descLabelText,
    isTaQtyEnabled,
    taQtyWidth,
    taQtyLabelText,
    isTaRateEnabled,
    taRateWidth,
    taRateLabelText,
    isTaDisEnabled,
    taDisWidth,
    taDisLabelText,
    isTaTaxPerEnabled,
    taTaxPerWidth,
    taTaxPerLabelText,
    isTaTaxAmtEnabled,
    taTaxAmtWidth,
    taTaxAmtLabelText,
    isTaAmtEnabled,
    taAmtWidth,
    taAmtLabelText,
    taBodyFontSize,
    isTaBodyBgColorEnabled,
    tempBgImg,
    taBodyBgColor,
    taBodyFontColor,
    taBodyDescColor,
    taBodyDescSize,
    isTaQtyUnitEnabled,
    QTItemArr,
    selectedModule
}) => {
    return (
        <>
            <table style={{ width: "100%", tableLayout: "fixed", clear: "both", borderTop: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}` }}
                className="temp-itemtable product-item-table" id="product-item-table" cellSpacing="0" cellPadding="0" border="0">
                <thead>
                    <tr style={{ height: "17px" }}>
                        {!isLineItemNumCheckEnabled ? ('') : (
                            <td
                                style={{
                                    padding: "5px 5px 2px 5px", width: `${lineNumWidth}%`, textAlign: "center",
                                    wordWrap: "break-word", fontWeight: "normal",
                                    fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    borderLeft: "0px"
                                }}
                                valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                <b>{lineNumLabelText}</b>
                            </td>
                        )}
                        <td
                            style={{
                                padding: "5px 7px 2px 7px", width: `${itemWidth}%`, textAlign: "left",
                                wordWrap: "break-word", fontWeight: "normal",
                                fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`
                            }}
                            valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                            <b>
                                {!isItemEnabled ? ('') : (itemLabelText)} {isItemEnabled && isDescLabelEnabled ? (<>&amp;</>) : ('')}
                                {!isDescLabelEnabled ? ('') : (<>{' '} {descLabelText}</>)}
                            </b>
                        </td>
                        {!isTaQtyEnabled ? ('') : (
                            <td
                                style={{
                                    padding: "5px 7px 2px 7px", width: `${taQtyWidth}%`, textAlign: "right",
                                    wordWrap: "break-word", fontWeight: "normal",
                                    fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`
                                }}
                                valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                <b>{taQtyLabelText}</b>
                            </td>
                        )}
                        {!isTaRateEnabled ? ('') : (
                            <td
                                style={{
                                    padding: "5px 7px 2px 7px", width: `${taRateWidth}%`, textAlign: "right",
                                    wordWrap: "break-word", fontWeight: "normal",
                                    fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`
                                }}
                                valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                <b>{taRateLabelText}</b>
                            </td>
                        )}
                        {!isTaDisEnabled ? ('') : (
                            <td
                                style={{
                                    padding: "5px 7px 2px 7px", width: `${taDisWidth}%`, textAlign: "right",
                                    wordWrap: "break-word", fontWeight: "normal",
                                    fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`
                                }}
                                valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                <b>{taDisLabelText}</b>
                            </td>
                        )}
                        {!isTaTaxPerEnabled ? ('') : (
                            <td
                                style={{
                                    padding: "5px 7px 2px 7px", width: `${taTaxPerWidth}%`, textAlign: "right",
                                    wordWrap: "break-word", fontWeight: "normal",
                                    fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`
                                }}
                                valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                <b>{taTaxPerLabelText}</b>
                            </td>
                        )}
                        {!isTaTaxAmtEnabled ? ('') : (
                            <td
                                style={{
                                    padding: "5px 7px 2px 7px", width: `${taTaxAmtWidth}%`, textAlign: "right",
                                    wordWrap: "break-word", fontWeight: "normal",
                                    fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`
                                }}
                                valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                <b>{taTaxAmtLabelText}</b>
                            </td>
                        )}
                        {!isTaAmtEnabled ? ('') : (
                            <td
                                style={{
                                    padding: "5px 7px 2px 7px", width: `${taAmtWidth}%`, textAlign: "right",
                                    wordWrap: "break-word", fontWeight: "normal",
                                    fontSize: `${taHeadFontSize}pt`, color: taHeadFontColor, backgroundColor: `${isTaHeadBgColorEnabled ? taHeadBgColor : 'transparent'}`,
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    borderRight: "0px"
                                }}
                                valign="bottom" rowSpan="2" className="temp-itemtable-header temp-itemtable-breakword">
                                <b>{taAmtLabelText}</b>
                            </td>
                        )}
                    </tr>
                </thead>
                <tbody className="itemBody product-item-table-body">
                    <tr className="breakrow-inside breakrow-after product-item-table-row" style={{ height: "20px", pageBreakAfter: "auto", pageBreakInside: "avoid" }}>
                        {!isLineItemNumCheckEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "center", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor,
                                    borderLeft: "0"
                                }}>
                                {/* {"${SALES ORDERS.item.S.No}"} */}
                                {"${" + selectedModule.toUpperCase() + ".item.S.No}"}
                            </td>
                        )}
                        <td valign="top" className="temp-item-row"
                            style={{
                                padding: "1px 5px", wordWrap: "break-word",
                                borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                            }}>
                            <div>
                                {/* <span style={{ wordWrap: "break-word" }}>{"${SALES ORDERS.Item.Product Name}"}</span><br /> */}
                                <span style={{ wordWrap: "break-word" }}>{"${" + selectedModule.toUpperCase() + ".Item.Product Name}"}</span><br />
                                {/* <span style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", color: taBodyDescColor, fontSize: `${taBodyDescSize}pt` }} className="temp-item-desc">{"${SALES ORDERS.Item.Description}"}</span><br /> */}
                                {QTItemArr.map((data) => (
                                    <><span style={{ wordWrap: "break-word" }}>{data}</span><br /></>
                                ))}
                            </div>
                        </td>
                        {!isTaQtyEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                {/* {"${SALES ORDERS.Item.Quantity}"} */}
                                {"${" + selectedModule.toUpperCase() + ".Item.Quantity}"}
                                {/* {!isTaQtyUnitEnabled ? ('') : (<div>Nos</div>)} */}
                            </td>
                        )}
                        {!isTaRateEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                {/* {"${SALES ORDERS.Item.List Price}"} */}
                                {"${" + selectedModule.toUpperCase() + ".Item.List Price}"}
                            </td>
                        )}
                        {!isTaDisEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                {/* {"${SALES ORDERS.Item.Discount}"} */}
                                {"${" + selectedModule.toUpperCase() + ".Item.Discount}"}
                            </td>
                        )}
                        {!isTaTaxPerEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                {/* <span>{"${SALES ORDERS.Item.Tax}"}</span> */}
                                <span>{"${" + selectedModule.toUpperCase() + ".Item.Tax}"}</span>
                            </td>
                        )}
                        {/* {!isTaTaxAmtEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                <span></span>
                                <span>{"${SALES ORDERS.Item.Tax}"}</span>
                            </td>
                        )} */}
                        {!isTaAmtEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor,
                                    borderRight: "0"
                                }}>
                                {/* {"${SALES ORDERS.Item.Total}"} */}
                                {"${" + selectedModule.toUpperCase() + ".Item.Total}"}
                            </td>
                        )}
                    </tr>
                    {/* <tr className="breakrow-inside breakrow-after d-none" style={{ height: "20px", pageBreakAfter: "auto", pageBreakInside: "avoid" }}>
                        {!isLineItemNumCheckEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "center", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor,
                                    borderLeft: "0"
                                }}>
                                2
                            </td>
                        )}
                        <td valign="top" className="temp-item-row"
                            style={{
                                padding: "1px 5px", wordWrap: "break-word",
                                borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                            }}>
                            <div>
                                <span style={{ wordWrap: "break-word" }}>Web Design Packages(Template) - Basic</span><br />
                                <span style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", color: taBodyDescColor, fontSize: `${taBodyDescSize}pt` }} className="temp-item-desc">Custom Themes for your business. Inclusive of 10 hours of marketing and annual training</span><br />
                            </div>
                        </td>
                        {!isTaQtyEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                1.00
                                {!isTaQtyUnitEnabled ? ('') : (<div>Nos</div>)}
                            </td>
                        )}
                        {!isTaRateEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                250.00
                            </td>
                        )}
                        {!isTaDisEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                0.00
                            </td>
                        )}
                        {!isTaTaxPerEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                <span>4.70%</span>
                            </td>
                        )}
                        {!isTaTaxAmtEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                <span>11.75</span>
                            </td>
                        )}
                        {!isTaAmtEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor,
                                    borderRight: "0"
                                }}>
                                250.00
                            </td>
                        )}
                    </tr>
                    <tr className="breakrow-inside breakrow-after d-none tst" style={{ height: "20px", pageBreakAfter: "auto", pageBreakInside: "avoid" }}>
                        {!isLineItemNumCheckEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "center", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor,
                                    borderLeft: "0"
                                }}>
                                3
                            </td>
                        )}
                        <td valign="top" className="temp-item-row"
                            style={{
                                padding: "1px 5px", wordWrap: "break-word",
                                borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                            }}>
                            <div>
                                <span style={{ wordWrap: "break-word" }}>Print Ad - Basic - Color</span><br />
                                <span style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", color: taBodyDescColor, fontSize: `${taBodyDescSize}pt` }} className="temp-item-desc">Print Ad 1/8 size Color</span><br />
                            </div>
                        </td>
                        {!isTaQtyEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                1.00
                                {!isTaQtyUnitEnabled ? ('') : (<div>Nos</div>)}
                            </td>
                        )}
                        {!isTaRateEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                80.00
                            </td>
                        )}
                        {!isTaDisEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                0.00
                            </td>
                        )}
                        {!isTaTaxPerEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                <span></span>
                            </td>
                        )}
                        {!isTaTaxAmtEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor
                                }}>
                                <span></span>
                            </td>
                        )}
                        {!isTaAmtEnabled ? ('') : (
                            <td valign="top" className="temp-item-row"
                                style={{
                                    textAlign: "right", padding: "1px 5px", wordWrap: "break-word",
                                    borderRight: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`, borderBottom: `1px solid ${isTableBorderEnabled ? tempBorderColor : 'transparent'}`,
                                    fontSize: `${taBodyFontSize}pt`, backgroundColor: `${isTaBodyBgColorEnabled && !tempBgImg ? taBodyBgColor : 'transparent'}`, color: taBodyFontColor,
                                    borderRight: "0"
                                }}>
                                80.00
                            </td>
                        )}
                    </tr> */}
                </tbody>
            </table >
        </>
    )
}
export default TableContent;